import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { MessageDialog } from '../../components/message-dialog/messageDialog';
import { AppConfig } from '../../core/configuration/app.config';
import { Cliente } from '../../core/models/cliente.model';
import { ClienteService } from '../../core/services/cliente.service';

@Component({
  selector: 'app-a3Laboral-settings',
  templateUrl: './a3Laboral-settings.component.html',
  styleUrls: ['./a3Laboral-settings.component.scss'],
  providers: [ClienteService]
})
export class A3LaboralSettingsComponent implements OnInit {

  model: Cliente;
  typeSecretA3Laboral = 'password';
  typeOcpApimSubscriptionKey = 'password';

  constructor(private _clienteService: ClienteService,
    protected _messageDialog: MessageDialog,
    protected _http: HttpClient) { }

  ngOnInit() {
    this._clienteService.getModel().subscribe(
      res => {
        this.model = res[0]
      },
      err => this._messageDialog.ShowAlert("No se ha podido obtener el cliente", "Error"));
  }

  save() {
    this._clienteService.update(this.model.Id, this.model).subscribe(res=> {
      this._messageDialog.ShowMessage("Actualización realizada con éxito", "Atención");
    },
    err => this._messageDialog.ShowException(err));
  }

  LoginA3Laboral(){
    const url = `${AppConfig.settings.apiServer.apiUrl.replace("/api", "")}Login/GoToLogin`;

    this._http.get<string>(url)
      .subscribe((res: string)=> {
        //console.log(res);
        document.location.href = res;
      });

  }

  toggleTypeSecretA3Laboral() {
    this.typeSecretA3Laboral = this.typeSecretA3Laboral === 'password' && 'text';
  }

  toggleTypeOcpApimSubscriptionKey() {
    this.typeOcpApimSubscriptionKey = this.typeOcpApimSubscriptionKey === 'password' && 'text';
  }

}
